import type { CampaignInfluencer } from "@/marketing/models/campaignInfluencer";

// Matches any selected tag or, when requested, creators without visible active tags.
export function filterCreatorsByTags(
  creators: CampaignInfluencer[],
  selectedTagIds: string[],
  untagged?: { include: boolean; tagNameById: ReadonlyMap<string, string> },
): CampaignInfluencer[] {
  if (selectedTagIds.length === 0 && !untagged?.include) return creators;

  return creators.filter((creator) =>
    creator.tags?.some((tagId) => selectedTagIds.includes(tagId)) ||
    (untagged?.include &&
      !creator.tags?.some((tagId) => untagged.tagNameById.has(tagId))),
  );
}

export function keepActiveTagIds(
  selectedTagIds: string[],
  tagNameById: Map<string, string>,
): string[] {
  return selectedTagIds.filter((tagId) => tagNameById.has(tagId));
}
